import { AWS_AUTH_TYPES } from "integrations/aws/common/constants";
export const toAWSCloudTrailInputCreateRequest = ({
  awsCloudTrailName,
  awsAuthenticationType,
  awsCloudTrailThrottleEnabled,
  pollingInterval,
  awsAccessKey,
  awsSecretKey,
  awsCloudTrailSqsQueueName,
  awsCloudTrailSqsRegion,
  awsCloudTrailS3Region,
  awsAssumeRoleArn,
  overrideSource,
  key,
  secret,
  sqsMessageBatchSize,
  includeFullMessageJson
}) => ({
  name: awsCloudTrailName == null ? void 0 : awsCloudTrailName.value,
  ...(awsAuthenticationType == null ? void 0 : awsAuthenticationType.value) === AWS_AUTH_TYPES.keysecret ? {
    aws_access_key: awsAccessKey == null ? void 0 : awsAccessKey.value,
    aws_secret_key: awsSecretKey == null ? void 0 : awsSecretKey.value
  } : {
    aws_access_key: key,
    aws_secret_key: secret
  },
  polling_interval: pollingInterval == null ? void 0 : pollingInterval.value,
  enable_throttling: !!(awsCloudTrailThrottleEnabled == null ? void 0 : awsCloudTrailThrottleEnabled.value),
  aws_sqs_queue_name: awsCloudTrailSqsQueueName == null ? void 0 : awsCloudTrailSqsQueueName.value,
  aws_sqs_region: awsCloudTrailSqsRegion == null ? void 0 : awsCloudTrailSqsRegion.value,
  aws_s3_region: awsCloudTrailS3Region == null ? void 0 : awsCloudTrailS3Region.value,
  assume_role_arn: awsAssumeRoleArn == null ? void 0 : awsAssumeRoleArn.value,
  override_source: overrideSource == null ? void 0 : overrideSource.value,
  sqs_message_batch_size: sqsMessageBatchSize == null ? void 0 : sqsMessageBatchSize.value,
  include_full_message_json: !!(includeFullMessageJson == null ? void 0 : includeFullMessageJson.value)
});
export const toGenericInputCreateRequest = ({
  awsCloudTrailName,
  awsAuthenticationType,
  awsCloudTrailThrottleEnabled,
  awsAccessKey,
  awsSecretKey,
  pollingInterval,
  awsCloudTrailSqsQueueName,
  awsCloudTrailSqsRegion,
  awsCloudTrailS3Region,
  awsAssumeRoleArn,
  key,
  secret,
  overrideSource,
  sqsMessageBatchSize,
  includeFullMessageJson
}) => ({
  type: "org.graylog.aws.inputs.cloudtrail.CloudTrailInput",
  title: awsCloudTrailName == null ? void 0 : awsCloudTrailName.value,
  global: false,
  configuration: {
    ...(awsAuthenticationType == null ? void 0 : awsAuthenticationType.value) === AWS_AUTH_TYPES.keysecret ? {
      aws_access_key: awsAccessKey == null ? void 0 : awsAccessKey.value,
      aws_secret_key: awsSecretKey == null ? void 0 : awsSecretKey.value
    } : {
      aws_access_key: key,
      aws_secret_key: secret
    },
    polling_interval: pollingInterval == null ? void 0 : pollingInterval.value,
    throttling_allowed: !!(awsCloudTrailThrottleEnabled == null ? void 0 : awsCloudTrailThrottleEnabled.value),
    aws_sqs_queue_name: awsCloudTrailSqsQueueName == null ? void 0 : awsCloudTrailSqsQueueName.value,
    aws_sqs_region: awsCloudTrailSqsRegion == null ? void 0 : awsCloudTrailSqsRegion.value,
    aws_s3_region: awsCloudTrailS3Region == null ? void 0 : awsCloudTrailS3Region.value,
    assume_role_arn: awsAssumeRoleArn == null ? void 0 : awsAssumeRoleArn.value,
    override_source: overrideSource == null ? void 0 : overrideSource.value,
    sqs_message_batch_size: sqsMessageBatchSize == null ? void 0 : sqsMessageBatchSize.value,
    include_full_message_json: !!(includeFullMessageJson == null ? void 0 : includeFullMessageJson.value)
  }
});
